(function () {
  var FORM_EMBED_URL = 'https://link.msgsndr.com/js/form_embed.js';
  var LOADER_HTML =
    '<div class="lma-modal-loader" role="status" aria-live="polite">' +
    '<span class="lma-modal-loader__spinner" aria-hidden="true"></span>' +
    '<span class="lma-modal-loader__text">Loading form…</span>' +
    '</div>';

  function getLeadConnectorIframe(modal) {
    return modal.querySelector('iframe[data-src], iframe[src*="link.msgsndr.com"]');
  }

  function ensureModalLoader(modal) {
    var body = modal.querySelector('.lma-modal-body');
    if (!body || body.querySelector('.lma-modal-loader')) return body;
    body.insertAdjacentHTML('beforeend', LOADER_HTML);
    return body;
  }

  function setModalLoading(modal, isLoading) {
    var body = ensureModalLoader(modal);
    if (!body) return;
    body.classList.toggle('is-loading', isLoading);
    modal.classList.toggle('is-loading', isLoading);
  }

  function modalNeedsIframeLoad(modal) {
    var iframe = getLeadConnectorIframe(modal);
    if (!iframe) return false;
    if (iframe.getAttribute('data-lma-iframe-loaded') === 'true') return false;
    return !!(iframe.getAttribute('data-src') || iframe.getAttribute('src'));
  }

  function markIframeLoaded(iframe) {
    iframe.setAttribute('data-lma-iframe-loaded', 'true');
  }

  function runFormEmbedCallbacks() {
    var callbacks = window.lmaFormEmbedCallbacks || [];
    window.lmaFormEmbedCallbacks = [];
    callbacks.forEach(function (cb) {
      cb();
    });
  }

  function markEmbedScriptLoaded(script) {
    window.lmaFormEmbedLoaded = true;
    window.lmaFormEmbedLoading = false;
    if (script) {
      script.setAttribute('data-lma-form-embed', 'true');
    }
    runFormEmbedCallbacks();
  }

  function createFormEmbedScript() {
    var script = document.createElement('script');
    script.setAttribute('data-lma-form-embed', 'true');
    script.setAttribute('data-lma-app-opt', 'true');
    script.type = 'text/javascript';
    script.defer = true;
    script.onload = function () {
      markEmbedScriptLoaded(script);
    };
    script.onerror = function () {
      window.lmaFormEmbedLoading = false;
      runFormEmbedCallbacks();
    };
    script.src = FORM_EMBED_URL;
    return script;
  }

  function ensureFormEmbedScript(callback) {
    if (typeof callback === 'function') {
      window.lmaFormEmbedCallbacks = window.lmaFormEmbedCallbacks || [];
      window.lmaFormEmbedCallbacks.push(callback);
    }

    if (window.lmaFormEmbedLoaded || typeof window.iFrameResize === 'function') {
      window.lmaFormEmbedLoaded = true;
      runFormEmbedCallbacks();
      return;
    }

    var existing = document.querySelector('script[data-lma-form-embed], script[src*="link.msgsndr.com/js/form_embed.js"]');
    if (existing) {
      if (existing.getAttribute('type') === 'javascript/blocked') {
        var replacement = createFormEmbedScript();
        existing.parentNode.replaceChild(replacement, existing);
        return;
      }
      if (!window.lmaFormEmbedLoading) {
        existing.addEventListener(
          'load',
          function () {
            markEmbedScriptLoaded(existing);
          },
          { once: true }
        );
      }
      return;
    }

    if (window.lmaFormEmbedLoading) return;
    window.lmaFormEmbedLoading = true;
    document.body.appendChild(createFormEmbedScript());
  }

  function watchIframeLoad(modal, iframe) {
    var finished = false;

    function finish() {
      if (finished) return;
      finished = true;
      markIframeLoaded(iframe);
      setModalLoading(modal, false);
    }

    iframe.addEventListener('load', finish, { once: true });
    iframe.addEventListener('error', finish, { once: true });
    window.setTimeout(finish, 20000);
  }

  function loadModalIframes(modal) {
    var iframe = getLeadConnectorIframe(modal);
    if (!iframe || iframe.getAttribute('data-lma-iframe-loaded') === 'true') return;

    watchIframeLoad(modal, iframe);

    var url = iframe.getAttribute('data-src');
    if (url && !iframe.getAttribute('src')) {
      ensureFormEmbedScript(function () {
        iframe.setAttribute('src', url);
      });
      return;
    }

    if (iframe.getAttribute('src')) {
      ensureFormEmbedScript(function () {});
    }
  }

  function initInlineLeadConnectorForms() {
    var iframes = document.querySelectorAll('iframe[src*="link.msgsndr.com"]');
    for (var i = 0; i < iframes.length; i++) {
      if (!iframes[i].closest('.lma-modal')) {
        ensureFormEmbedScript();
        return;
      }
    }
  }

  function getModalIdFromHref(href) {
    if (!href || href.indexOf('#modal:') !== 0) return '';
    var slug = href.slice('#modal:'.length).split(/[?#]/)[0];
    return slug ? 'lma-modal-' + slug : '';
  }

  function setupModalLinks() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#modal:"]');
      if (!link) return;

      var modalId = getModalIdFromHref(link.getAttribute('href'));
      if (!modalId || !document.getElementById(modalId)) return;

      e.preventDefault();
      window.openLmaModal(modalId);
    });
  }

  function initModalSystem() {
    if (typeof window.lmaModalsInitialized !== 'undefined') return;
    window.lmaModalsInitialized = true;

    window.openLmaModal = function (modalId) {
      var modal = document.getElementById(modalId);
      if (!modal) return;

      if (modalNeedsIframeLoad(modal)) {
        setModalLoading(modal, true);
      }

      loadModalIframes(modal);
      modal.classList.add('is-active');

      var body = document.body;
      var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      var originalPaddingRight = window.getComputedStyle(body).paddingRight;

      body.dataset.paddingRight = originalPaddingRight;
      body.style.paddingRight = parseInt(originalPaddingRight || 0, 10) + scrollbarWidth + 'px';
      body.style.overflow = 'hidden';
      try {
        window.dispatchEvent(new CustomEvent('lma:modal:open', { detail: { modalId: modalId } }));
      } catch (e) {}
    };

    window.closeLmaModal = function (modalId) {
      var modal = document.getElementById(modalId);
      if (!modal) return;
      modal.classList.remove('is-active', 'is-loading');
      var modalBody = modal.querySelector('.lma-modal-body');
      if (modalBody) modalBody.classList.remove('is-loading');
      var body = document.body;
      body.style.paddingRight = body.dataset.paddingRight || '';
      body.style.overflow = '';
      delete body.dataset.paddingRight;
      try {
        window.dispatchEvent(new CustomEvent('lma:modal:close', { detail: { modalId: modalId } }));
      } catch (e) {}
    };

    setupModalLinks();
    initInlineLeadConnectorForms();

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.lma-modal.is-active').forEach(function (modal) {
        window.closeLmaModal(modal.id);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initModalSystem);
  } else {
    initModalSystem();
  }
})();
